import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=5ed5ba0f&scoped=true&"
import script from "./HistoryPage.vue?vue&type=script&lang=js&"
export * from "./HistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=5ed5ba0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5ba0f",
  null
  
)

export default component.exports